<template>
  <header :class="pickClass">
    <div>
      <img
        class="logo"
        src="../assets/whitlamLogo.png"
      />
    </div>
    <h2>
      {{ titleFromProp }}
    </h2>

    <p class="sub-title" :style="styles">
      Booking Application
    </p>
  </header>
</template>

<script>
export default {
  props: ['titleFromProp', 'department'],
  data() {
    return {
      myStyle: { color: 'red' }
    };
  },

  methods: {},

  computed: {
    styles: function() {
      return { color: '#d5641c' };
    },
    pickClass: function() {
      return 'whitlam';
    }
  }
};

// background-color: #000000ba;
</script>

<style scoped>
header {
  width: 100%;
  height: 8rem;

  display: flex;
  justify-content: center;
  align-items: center;
}

header h2 {
  margin-bottom: 3rem;
  color: white;
  font-size: 200%;
  position: absolute;
  /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; */
}

.fchq,
.whitlam {
  background-color: black;
}

.fcc {
  background-color: #00509e;
}

.logo {
  height: 6rem;
  float: left;
  position: absolute;
  left: 10px;
  top: 10px;
}

.sub-default {
  color: #ccc;
}

.sub-title {
  margin-top: 5rem;
  /* font-family: 'Franklin Gothic', 'Arial Narrow', Arial, sans-serif; */
  font-weight: lighter;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 150%;
}

@media (max-width: 768px) {
  .logo {
    height: 2rem;
    float: left;

    left: 10px;
    top: 0rem;
  }
  .sub-title {
    font-size: 70%;
    margin-top: 20px;
  }
  header h2 {
    margin-top: 5px;
    font-size: 80%;
    position: absolute;
    /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; */
  }

  header {
    margin-left: 0rem;
    height: 4rem;
  }
}
</style>
